export default __webpack_public_path__ + "static/media/commercial-video-keyvisual.37d1b0b4.svg";